module.exports = __webpack_public_path__ + "c9b82193d46748f4f83a070c4cadd056.svg";